import React from 'react';
import ReactDOM from 'react-dom';
import Game from './game/game.js';

ReactDOM.render(
  <Game />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js